import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Checkbox from "../Checkbox/Checkbox";
import { permissionActions, permissionCategories } from "../../utils/constants";
import { isActionAllowed } from "../../utils/utils";

const PermissionsTable = ({
  permissions,
  onPermissionChange,
  addRole,
  roleName,
  setRoleName,
}) => {
  const { t } = useTranslation();

  const isExistingPermission = (action, category) => {
    let isExists = false;
    if (permissions && permissions.length) {
      isExists = permissions.find((p) => p === action + "_" + category);
    }
    return isExists;
  };

  return (
    <>
      {addRole && (
        <Input
          placeholder={t("role-name")}
          value={roleName}
          onChange={(e) => setRoleName(e.target.value)}
        />
      )}
      <TableWrapper>
        <StyledTable>
          <TableHead>
            <TableRow>
              <HeaderCell $isFirst>{t("actions")}</HeaderCell>
              {permissionActions.map((action) => (
                <HeaderCell key={action.key}>{t(action.label)}</HeaderCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {permissionCategories.map((category, index) => (
              <TableRow key={index}>
                <DataCell $isFirst>{t(category.label)}</DataCell>
                {permissionActions.map((action) => (
                  <DataCell key={action.key}>
                    {isActionAllowed(category.key, action.key) && (
                      <Checkbox
                        size={24}
                        checked={isExistingPermission(action.key, category.key)}
                        onChange={() =>
                          onPermissionChange(category.key, action.key)
                        }
                      />
                    )}
                  </DataCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableWrapper>
    </>
  );
};

export default PermissionsTable;

const Input = styled.input`
  position: relative;

  border-radius: 10px;
  user-select: none;
  height: 45px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  border: none;
  padding: 15px;

  border-radius: 10px;

  user-select: none;
  width: 100%;
  max-width: 300px;
  border: none;
  height: 45px;
  font-family: "Avenir-Medium";
  font-size: 1.2rem;
  letter-spacing: 0.067px;

  margin-bottom: -3rem;
  margin-top: 2rem;
  &:active {
    outline: none;
  }
  &::placeholder {
    color: #484888;

    opacity: 0.75;
  }
`;

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  background: white;
  border-radius: 3rem;

  /* padding: 3rem; */
  overflow: auto;
  margin-top: 4rem;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHead = styled.thead`
  background-color: #f8f8fc;
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  &:last-child {
    border-bottom: none;
  }
`;

const HeaderCell = styled.th`
  padding: 1.6rem 2rem;
  text-align: ${(props) => (props.$isFirst ? "left" : "center")};
  font-family: "Avenir";
  font-size: 1.8rem;
  line-height: 2.5rem;
  color: #484888;
  font-weight: 600;
  min-width: ${(props) => (props.$isFirst ? "20rem" : "12rem")};
`;

const DataCell = styled.td`
  padding: 1.6rem 2rem;
  text-align: ${(props) => (props.$isFirst ? "left" : "center")};
  font-family: "Avenir-Medium";
  font-size: 1.6rem;
  color: #484888;
  min-height: 6rem;
`;
